import $ from 'jquery';
import Backbone from 'backbone';
import OneDrawer from '@/modules/module-oneDrawer';
import OneContact from '@/modules/module-oneContact';

import '../../styles/modules/oneSubscribe.scss';

const OneSubscribeView = Backbone.View.extend({
  initialize(settings) {
    this.$modal = this.$el;
    if (!this.$modal.length) return;

    this.enabled = this.$modal.data('enabled');
    this.integrationType = settings.integrationType || this.$modal.data('type');
    this.errorMsg = settings.errorMsg || this.$modal.data('errormsg');
    this.successMsg = settings.successMsg || this.$modal.data('successmsg');
    this.errorRequired =
      settings.requiredMsg || this.$modal.data('requiredmsg');
    this.errorEmail = settings.errorEmail || this.$modal.data('erroremail');
    this.delay = settings.delay || this.$modal.data('delay');
    this.days = settings.cookieDays || this.$modal.data('cookiedays');
    this.cookieEnabled =
      settings.cookieEnabled || this.$modal.data('cookieenabled');
    this.$form = this.$modal.find('form');

    if (!this.enabled) return;

    this.initModal();
    this.initForm();
  },

  events: {
    'click .close': 'handleClose',
    'click .global-message a': 'handleGlobalLink',
    'click .global-message': 'clearGlobalMessage'
  },

  handleClose(e) {
    this.close(true);
  },

  handleGlobalLink(e) {
    e.preventDefault();
    const $curr = $(e.currentTarget);
    if ($curr.attr('href')) window.open($curr.attr('href'));
  },

  clearGlobalMessage() {
    this.$form.parent().removeClass('submitted error success');
  },

  initModal() {
    this.subscribeDrawer = OneDrawer.init({
      drawerElem: '#SubscribeModal',
      triggerEvent: 'click',
      triggerElem: '.subscribe-modal-trigger'
    });

    const showModal = () => setTimeout(() => this.open(), this.delay);

    if (
      theme.configs.cookieBannerEnabled &&
      ORW.utilities.getCookie('acceptcookieterm')
    ) {
      showModal();
    } else if (!theme.configs.cookieBannerEnabled) {
      showModal();
    }
  },

  initForm() {
    const submitType = this.integrationType === 'klaviyo' ? 'custom' : 'json';

    OneContact.init({
      el: this.$modal,
      submitType,
      errorMsg: this.errorMsg,
      successMsg: this.successMsg,
      requiredMsg: this.errorRequired,
      errorEmail: this.errorEmail,
      onSubmit: (e) => console.log(e),
      successCallback: (data) => this.submitCallBack(true, data),
      errorCallback: (err) => this.submitCallBack(false, err)
    });

    if (this.integrationType === 'klaviyo') {
      const formId = `#${this.$form.attr('id')}`;

      KlaviyoSubscribe.attachToForms(formId, {
        hide_form_on_success: false,
        success: () => {
          this.submitCallBack(true, { success: true, msg: this.successMsg });
        },
        custom_success_message: true,
        success_message: this.successMsg,
        extra_properties: {
          $source: 'Fly Out',
          $method_type: 'Klaviyo Form',
          $method_id: 'embed'
        }
      });

      KlaviyoSubscribe.injectCSS(false);
      this.$form.removeClass('klaviyo_styling');
    }
  },

  open() {
    if (
      !ORW.utilities.getCookie('hidesubscriptionmodal') ||
      !this.cookieEnabled
    ) {
      this.subscribeDrawer.openDrawer();
    }
  },

  close(setCookie) {
    this.subscribeDrawer.closeDrawer();
    if (setCookie && this.cookieEnabled) {
      ORW.utilities.setCookie('hidesubscriptionmodal', true, this.days);
    }
  },

  submitCallBack(isSuccess, data) {
    const $container = this.$form.parent();
    let $globalMsg = $container.find('.global-message');
    const showMessage = (msg, type) => {
      msg = `<span>${msg}</span>`;
      if ($globalMsg.length) {
        $globalMsg.html(msg);
      } else {
        $container.append(`<p class="global-message">${msg}</p>`);
        $globalMsg = $container.find('.global-message');
      }
      $container
        .removeClass('submitted error success')
        .addClass(`submitted ${type}`);

      if (type === 'success') {
        this.$form.find('.group input').each(function () {
          const $input = $(this);
          if ($input.attr('type') === 'checkbox') {
            $input.prop('checked', false);
          } else if ($input.attr('type') !== 'radio') {
            $input.val('');
          }
        });
      }
    };

    if (isSuccess && (data.result === 'success' || data.success)) {
      showMessage(this.successMsg, 'success');
      const delay = this.delay > 3000 ? this.delay : 3000;
      setTimeout(() => this.close(true), delay);
    } else {
      showMessage(isSuccess ? data.msg : this.errorMsg, 'error');
    }
  },

  destroy() {
    this.undelegateEvents();
  }
});

const OneSubscribe = {
  init(settings) {
    return new OneSubscribeView(settings);
  }
};

export default OneSubscribe;
